import { render, staticRenderFns } from "./standing_switch.vue?vue&type=template&id=f4e514e0&scoped=true"
import script from "./standing_switch.vue?vue&type=script&lang=js"
export * from "./standing_switch.vue?vue&type=script&lang=js"
import style0 from "./standing_switch.vue?vue&type=style&index=0&id=f4e514e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e514e0",
  null
  
)

export default component.exports